import React, {FC} from 'react'
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

type Props ={
    close:boolean,
    handleClose: ()=> void,
    discountValue: string,
    courseDetail: any
}

const PromoDeskView:FC<Props> = ({close, handleClose, discountValue, courseDetail}) => {
   let navigate = useNavigate();
  return (
    <>
    <div className={close ? 'hidden':  'sm:hidden md:hidden cursor-pointer w-[100%]  h-[90px] bg-[#0f5a0d] fixed top-0 z-[999] pr-4'}>
    <div className='flex'>
    <FontAwesomeIcon onClick={handleClose} className="bg-[#FFFFFF] cursor-pointer h-[15px] w-[15px] rounded-[50%] ml-auto mt-1" icon={faXmark} style={{color: "#0f5a0d",}} /></div>
    <div>
    <ul onClick={()=>{navigate(`/coursedetails/${courseDetail?.CourseName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}`)}} className='flex items-center justify-between mx-10 '>
    
      <li className="flex justify-center items-centered  ">
        <li >
       <li className="text-[23px] text-[#FFFFFF]">SPECIAL</li>
       <li className="text-[28px] text-[#FFFFFF] -mt-[15px]">OFFER</li>
      </li>
    
      <li className=" text-center h-[60px] w-[60px] rounded-[50%] ml-1 bg-[#FFFFFF]">
       <li className="text-[#0f5a0d] text-[26px] font-[700] mt-[10px]">{discountValue}%</li>
       <li className="text-[#0f5a0d] text-[12px] font-[400] -mt-3">OFF</li>
      </li>
    
      </li>
    
      <li className='flex flex-col items-center '>
      <h1 className="text-[20px] text-[#FFFFFF]">Learn & Master</h1>
      <h1 className="text-[28px] text-[#FFFFFF] -mt-[10px]">{courseDetail?.CourseName}</h1>
      </li>
    
      <li className='bg-[#FFFFFF] rounded-[10px] py-1  px-4'>
        <button onClick={()=>{navigate(`/coursedetails/${courseDetail?.CourseName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}`)}} className='border-none font-[700] text-[24px]  text-[#367E3E]'>Grab this offer</button>
      </li>
    
    </ul>
    
    
    
    </div>
    </div>

    </>
  )
}

export default PromoDeskView